import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/urbanist';
import App from './App';
import './global.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode><App /></React.StrictMode>,
);
